module.exports = __webpack_public_path__ + "img/6a1442e30010bf222414c9ca1fc35cf7.png";